export default "__VITE_ASSET__DacQGQUf__"